export default "__VITE_ASSET__CkTl$yjW__"